const news = `Seit dem 29. April 2025 werden neben den dpa-Weblines auch der dpa-Basisdienst und die 12 dpa-Landesdienste als reichhaltige multimediale Artikel ausgeliefert.

Das heißt:

- Meldungen können verknüpfte Bilder enthalten (d.h. die \`associations\`-Liste im dpa-digitalwires-Format kann Einträge enthalten).
- Im Artikeltext (\`article_html\` im dpa-digitalwires-Format) kann es eingebettete Inhalte, z.B. positionierte Bilder (\`dnl-image\`) oder X-Posts (\`dnl-twitterembed\`), geben.


#### Beispielmeldung multimedialer Basisdienst

<codeblockbrowser to='/res/bdt-multimedial.json'></codeblockbrowser>`

export { news }


// WEBPACK FOOTER //
// ./src/all_cards/docu/news.js